import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfOrganizations } from '../../dobovoOrganizationSchema'

export default organizations => {
    const organizationsData = pathOr([], ['_embedded', 'dobovoOrganizations'], organizations)
    return { ...normalize(organizationsData, arrayOfOrganizations) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/dobovoParsers/dobovoOrganizations.js